import { useValidation } from "Hooks/useValidation";
import { TextFieldSetter } from "Views/Components/TextBox/TextFieldSetter";
import { produce } from "immer";
import { useContext, useEffect } from "react";
import { ESignEnvelopeCreateContext, ESignEnvelopeCreateDispatchContext } from "../ESignEnvelopeCreate";

export const ESignDocumentPreFillStage: React.FunctionComponent = () => {
	const { data: { preFillValues: prefillValues } } = useContext(ESignEnvelopeCreateContext);
	const dispatch = useContext(ESignEnvelopeCreateDispatchContext);

	const updatePrefillValues = (key: string, value: string) => {
		dispatch({ type: "SetPrefillValues", payload: { prefillValues: produce(prefillValues, draft => {
			draft[key] = value;
		}) } });
	}

	// validate the prefill values
	const validation = useValidation(
		Object.keys(prefillValues).reduce((acc, key) => {
			acc[key] = {
				value: prefillValues[key],
				isRequired: true,
				requiredText: `${key
					.split("-")
					.map(word => word.charAt(0).toUpperCase() + word.slice(1))
					.join(" ")} is required`,
			};
			return acc;
		}, {} as Record<string, any>)
	);

	useEffect(() => {
		dispatch({
			type: "StageValidation",
			payload: {
				stage: "common-fields",
				isValid: validation.isValid
			}
		});
		
	}, [validation.isValid, dispatch]);

	return (
		<div>
			<div className="alert alert__info">
				<p>This document contains fields that need to be filled out by you, the sender.</p>
			</div>
			{Object.keys(prefillValues).length > 0 ? (
				Object.entries(prefillValues).map(([key, value], index) => {
					const [error] = validation.get(key) || [];
					return (
						<TextFieldSetter
							key={index}
							label={key.split("-").map(word => word.charAt(0).toUpperCase() + word.slice(1)).join(" ")}
							value={value}
							setValue={newValue => { updatePrefillValues(key, newValue) }}
							errors={error}
						/>
					)
				})
			) : (
				<p>No pre-fill values available.</p>
			)}
		</div>
	)
}